// extracted by mini-css-extract-plugin
export default {"root":"style_root__FYg0p","icon":"style_icon__WsU99","label":"style_label__MSSaZ"};